import React, { useEffect, useState } from "react";
import ListHeader from "../../../../../components/listing/ListHeader";
import ListFooter from "../../../../../components/listing/ListFooter";
import DynamicTable from "../../../../../components/listing/DynamicTable";
import FiltroIva from "./FiltroIva";
import apiRoutes from "../../../../../api/apiRoutes";
import { appFetchJson } from "../../../../../utils/http";
import IconEdit from "../../../../../components/icons/IconEdit";
import IconTrash from "../../../../../components/icons/IconTrash";
import CrearIva from "./CrearIva";
import EditarIva from "./EditarIva";
import EliminarIva from "./EliminarIva";

export default function ListarIva() {
  const [porPagina, setPorPagina] = useState(30);
  const [pagina, setPagina] = useState(1);
  const [totalBackend, setTotalBackend] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const [mostrarCrear, setMostrarCrear] = useState(false);
  const [ivaAEditar, setIvaAEditar] = useState(null);
  const [ivaAEliminar, setIvaAEliminar] = useState(null);
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [filtros, setFiltros] = useState({ codigo: "", nombre: "", pr: "" });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const url = apiRoutes.ivas.listUrl({
          page: pagina - 1, size: porPagina,
          codigo: filtros.codigo.trim() || undefined,
          nombre: filtros.nombre.trim() || undefined,
          pr: filtros.pr || undefined,
        });
        const res = await appFetchJson(url);
        const items = Array.isArray(res?.items) ? res.items : [];
        setData(items);
        setTotalBackend(res?.totalElements ?? res?.total ?? items.length);
      } catch (e) {
        console.error("Error cargando IVA:", e);
        setError("Error al cargar los IVA.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [pagina, porPagina, filtros, reloadKey]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    const d = new Date(dateStr);
    return d.toLocaleDateString("es-PY", { day: "2-digit", month: "2-digit", year: "numeric" });
  };

  const columns = [
    { header: "Código", accessor: "codigo", type: "text", width: "15%", cellClass: "font-mono text-gray-600" },
    { header: "Descripción", accessor: "nombre", type: "text", width: "25%", cellClass: "font-medium text-gray-800" },
    { header: "Porcentaje", accessor: "pr", type: "text", width: "10%", cellClass: "text-gray-600" },
    {
      header: "Acción", type: "action", width: "20%",
      render: (row) => (
        <div className="flex justify-center items-center gap-2">
          <button title="Editar" onClick={() => setIvaAEditar(row)}><IconEdit /></button>
          <button title="Eliminar" onClick={() => setIvaAEliminar(row)}><IconTrash /></button>
        </div>
      ),
    },
  ];

  return (
    <div className="page">
      <ListHeader
        title="IVA"
        filters={filtros}
        onFilterClick={() => setMostrarFiltros(true)}
        onClearFilters={() => { setFiltros({ codigo: "", nombre: "", pr: "" }); setPagina(1); }}
        showAdd={true} addLabel="Agregar" onAddClick={() => setMostrarCrear(true)}
        pageSize={porPagina} onPageSizeChange={(size) => { setPorPagina(size); setPagina(1); }}
      />
      {loading && <div className="mt-2 text-sm text-gray-600">Cargando datos...</div>}
      {error && <div className="mt-2 text-sm text-red-600">{error}</div>}
      {mostrarFiltros && (
        <FiltroIva
          initialFilters={filtros}
          onSubmit={(nuevos) => { setFiltros(nuevos); setPagina(1); setMostrarFiltros(false); }}
          onClose={() => setMostrarFiltros(false)}
        />
      )}
      <DynamicTable size="S" data={data} columns={columns} />
      <ListFooter page={pagina} pageSize={porPagina} total={totalBackend} onPageChange={(p) => setPagina(p)} />
      {mostrarCrear && (
        <CrearIva onClose={() => setMostrarCrear(false)}
          onCreated={() => { setPagina(1); setReloadKey(k => k+1); setMostrarCrear(false); }} />
      )}
      {ivaAEditar && (
        <EditarIva initial={ivaAEditar} onClose={() => setIvaAEditar(null)}
          onSaved={() => { setReloadKey(k => k+1); setIvaAEditar(null); }} />
      )}
      {ivaAEliminar && (
        <div className="modal-backdrop" onClick={() => setIvaAEliminar(null)}>
          <div className="modal-panel-md" onClick={e => e.stopPropagation()}>
            <EliminarIva registro={ivaAEliminar} onClose={() => setIvaAEliminar(null)}
              onDeleted={() => { setReloadKey(k => k+1); setIvaAEliminar(null); }} />
          </div>
        </div>
      )}
    </div>
  );
}